import { createContext, useContext } from "react";
export const ExtensionManagerContext = createContext(undefined);
export function useExtensionManager() {
    return useContext(ExtensionManagerContext)?.extensionManager;
}
//# sourceMappingURL=extensionManagerContext.js.map